//TODO: При рефакторе, пройтись по всему проекту и поменять все дефолтные алерты
import React from "react";
import { Alert, AlertProps, Flex } from "antd";
import styles from "./style.module.css";

type CustomAlertProps = AlertProps & {
  variant?: "purple" | undefined;
};

export const CustomAlert: React.FC<CustomAlertProps> = ({ ...props }) => {
  return (
    <Flex>
      <Alert {...props} className={styles[props.variant ?? ""]} />
    </Flex>
  );
};
